import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import Title from 'components/backoffice/texts/title';
import HelpTextForm from 'components/backoffice/forms/helpTextForm';

const CreateHelpText = () => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext();

  useEffect(() => {
    setTitle(t('createHelpText'));
    return () => {
      setTitle('');
    };
  }, [setTitle]);

  return (
    <>
      <Title text={t('createHelpText')} />
      <HelpTextForm />
    </>
  );
};

export default CreateHelpText;
